import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CloudDownloadIcon = createIcon({
  displayName: 'CloudDownloadIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="12"
        y1="16.00001"
        x2="12"
        y2="21.00001"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <polyline
        points="10 19 12 21 14 19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.4008,17H7a5,5,0,0,1-5-5H2A4.98475,4.98475,0,0,1,6.32379,7.06818,5.9981,5.9981,0,0,1,12,3h0a6,6,0,0,1,6,6h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H16.5992"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const CloudDownload: FC<IconProps> = (props) => {
  return <CustomIcon as={CloudDownloadIcon} {...props} />
}

export default memo(CloudDownload)
